import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../../../constants/brandColors';
import { TaskListStyleConfig } from '../../../interfaces';

export const TaskListToDoStyles = makeStyles((theme: Theme) =>
  createStyles({
    tileHeader: {
      height: '100%',
      flexDirection: 'column',
    },
    lock: {
      textAlign: 'center',
      paddingTop: '7px',
      '& svg': {
        width: 16,
        height: 'auto',
      },
    },
    containerTaskList: (props: TaskListStyleConfig) => ({
      backgroundColor: props.taskContainerColor || theme.palette.background.paper, //task list container background color
    }),
    bottomShadowTaskList: (props: TaskListStyleConfig) => ({
      paddingBottom: '20px',
      '&::before': {
        bottom: '0px !important',
        width: '100% !important',
        background: `linear-gradient(180deg, ${BrandColors.scoreCardBg}  0%, ${
          props.taskContainerColor || theme.palette.background.paper
        } 68.33%) !important`, //tasklist bottomShadow background color
      },
    }),
    customDivider: (props: TaskListStyleConfig) => ({
      background: `${props.taskContainerColor || theme.palette.background.paper} !important`, //task list customDivider background color
    }),
    actionIconBorder: (props: TaskListStyleConfig) => ({
      borderRight: `1px solid ${BrandColors.modalBackdropColor}`,
      backgroundColor: props.tiles.backgroundColor || theme.palette.background.paper, // task tile background color, part of the ui where start button resides
      borderRadius: '4px 0 0 4px',
    }),
    taskListLabel: (props: TaskListStyleConfig) => ({
      marginTop: '0',
      justifyContent: 'center',
      color: props.taskListLabelAndDescriptionColor || theme.palette.text.primary, //task tile label color, default not given
      '&::after': {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'start',
      },
    }),
    tileCard: (props: TaskListStyleConfig) => ({
      backgroundColor: props.tiles.backgroundColor || theme.palette.background.paper,
      color: props.tiles.taskTileTextColor || theme.palette.text.primary, //overrids  taskTile.ts file and responsible for tile bacground and text color
      border: `1px solid ${BrandColors.modalBackdropColor}`,
      boxShadow: 'none',
    }),
    calenderIcon: (props: TaskListStyleConfig) => ({
      fontSize: 16,
      marginLeft: '0.25rem',
      color: props.taskListLabelAndDescriptionColor || theme.palette.text.primary, //task tile label color for calender icon, default is '#4A4A4A'
      [theme.breakpoints.down('md')]: {
        fontSize: '1.20rem',
      },
    }),
    taskListLabelContainer: (props: TaskListStyleConfig) => ({
      '& .MuiTypography-subtitle1': {
        textAlign: 'center',
        color: props.taskListLabelAndDescriptionColor || theme.palette.text.primary, //task tile description color, default not given
        [theme.breakpoints.up('md')]: {
          textAlign: 'left',
        },
      },
    }),
    deadlineBox: {
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        justifyContent: 'end',
      },
    },
    deadlineDate: (props: TaskListStyleConfig) => ({
      fontSize: 11,
      letterSpacing: 'normal',
      height: 'auto',
      color: props.taskListLabelAndDescriptionColor || theme.palette.text.primary, //task tile label color for deadline date, default is '#4A4A4A'
      width: '14.75rem',
    }),
    timerText: (props: TaskListStyleConfig) => ({
      color: props.tiles.taskTileTextColor || theme.palette.text.primary, // given/overridden in taskTile.ts
      display: 'block',
      textAlign: 'center',
      width: '100%',
      marginLeft: 0,
    }),
    timerheader: (props: TaskListStyleConfig) => ({
      display: 'flex',
      alignItems: 'center',
      width: 'auto',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
      '& .MuiCardHeader-root': {
        width: '100%',
        paddingBottom: '4px',
        paddingTop: '2px',
        [theme.breakpoints.up('md')]: {
          paddingBottom: '7px',
          paddingTop: '7px',
        },
        '& .MuiTypography-subtitle1': {
          color: props.tiles.taskTileTextColor || theme.palette.text.primary, //task tile title color
        },
        '& .MuiTypography-subtitle2': {
          color: props.tiles.taskTileTextColor || theme.palette.text.primary, //task tile subtitle color
        },
      },
      '& span': {
        marginLeft: 'auto',
        display: 'inline-block',
        paddingLeft: '15px',
        paddingRight: '15px',
        whiteSpace: 'nowrap',
        fontSize: '11px',
        fontWeight: '600',
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: 'auto',
        },
      },
    }),
    optionalTask: (props: TaskListStyleConfig) => ({
      color: props.tiles.backgroundColor || theme.palette.background.paper, //optional label text color which is task tile backgound color,default is '#FFFFFF'
      backgroundColor: props.tiles.taskTileTextColor || theme.palette.text.primary, //optional label backgroundColor which is task tile text color,default is '#4A4A4A'
    }),
    startButton: (props: TaskListStyleConfig) => ({
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: `${props.tiles.startButtonColor || theme.palette.primary.main}`, //start button background color
      color: `${props.tiles.startButtonTextColor || theme.palette.primary.contrastText}`, //start button text color
    }),
    taskIconButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    taskIconLock: {
      height: 'calc(100% - 30px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    taskIcon: (props: TaskListStyleConfig) => ({
      '& > path': {
        fill: props.tiles.taskTileTextColor || props.tiles.textColor || theme.palette.text.primary,
      },
    }),
  }),
);
